import { isDevelopmentMode, sendRequest } from "../base";
export const getCommoditiesList = () => {
  return sendRequest(
    isDevelopmentMode() ? "/commodities" : "/trade/current-gold-price/"
  );
};
